import axios from "axios";
import { useEffect, useState } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import PaginationComp from "../components/PaginationComp";
import { root_url } from "../setting";
import { getBearerString } from "../utils/Auth";
import { dateString } from "./Notice";

const QNA = ({ history }) => {
  const [qnaList, setQnaList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const { pathname } = useLocation();
  const { location } = window;
  const [pageInfo, setPage] = useState({
    pageMaxNo: 0,
    active: 0,
  });
  const [checkList, setCheckList] = useState([]);
  const [queryThing, setQuery] = useState("title");
  const [searchString, setSearchString] = useState("");
  const [urlBeforePageNo, setUrlBeforePageNo] = useState({
    admin: "/admin/board/qna?pageNo=",
    user: "/dashboard/qna?pageNo=",
  });
  useEffect(() => {
    //url이 바뀌면 수행되어야 할 일들
    //1. 검색한 경우 => queryThing & pageNo 신경써야함
    //2. 검색하지 않은 경우 => pageNo만 신경쓰면됨
    const locationArr = window.location.toString().split("/");
    console.log(`locationArr ===> ${locationArr}`);
    //locationArr의 경우
    //1: qna?pageNo=1
    //2: qna?title=안녕&pageNo=1
    let locationStr = locationArr[locationArr.length - 1];
    console.log(`before : locationStr ===>${locationStr}`);
    if (locationStr.indexOf("&") >= 0) {
      locationStr = locationStr.split("&")[1];
    } else {
      locationStr = locationStr.split("?")[1];
    }
    console.log(`mod : locationStr ===>${locationStr}`);
    if (locationStr === "question") {
      return;
    } else {
      const pageNo = locationStr.split("=")[1];
      console.log(`pageNo ====> ${pageNo}`);
      let urlString = "";
      if (searchString !== "") {
        urlString = `${root_url}/api/qna?${queryThing}=${searchString}&pageNo=${pageNo}`;
        setUrlBeforePageNo({
          admin: `/admin/board/qna?${queryThing}=${searchString}&pageNo=`,
          user: `/dashboard/qna?${queryThing}=${searchString}&pageNo=`,
        });
      } else {
        urlString = `${root_url}/api/qna?pageNo=${pageNo}`;
      }
      console.log(`urlString ==>${urlString}`);
      axios({
        method: "get",
        url: urlString,
      })
        .then((res) => {
          const {
            data: { posts, pageMaxNo },
          } = res;
          console.log("여기서 바뀜 pageNo: " + pageNo);
          setPage({ pageMaxNo, active: pageNo });
          setQnaList(posts);

          setIsLoading(false);
          console.log(posts);
        })
        .catch((e) => {
          console.log(e);
          if (e.response === undefined) {
            alert(
              "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
            );
          } else {
            alert(e.response.data.errorMessage);
          }
        });

      // const fetchData = async () => {
      //   try {
      //     const {
      //       data: { posts, pageMaxNo },
      //     } = await axios.get(`${root_url}/api/qna?pageNo=${pageNo}`);
      //     console.log('pageNo: ' + pageNo);
      //     setPage({ pageMaxNo, active: pageNo });
      //     setQnaList(posts);
      //     setIsLoading(false);
      //     console.log(posts);
      //   } catch (e) {
      //     console.log(e);
      //     alert(
      //       '시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)'
      //     );
      //     setIsLoading(false);
      //   }
      // };
      if (pathname.startsWith("/admin")) {
        setIsAdmin(true);
      }
      // fetchData();
    }
  }, [location.toString()]);

  const onClickQuestion = () => {
    history.push({
      pathname: "/dashboard/qna/question",
    });
  };
  const onChangeAll = (e) => {
    const check_list_dict = {};
    if (e.target.checked) {
      for (let i in qnaList) {
        check_list_dict[qnaList[i].postNo] = true;
      }
    } else {
      for (let i in qnaList) {
        check_list_dict[qnaList[i].postNo] = false;
      }
    }
    setCheckList(check_list_dict);
  };
  return (
    <Container fluid>
      <h1 className="pt-5 mb-5">Q&A</h1>
      {isLoading ? (
        <div
          style={{ height: "50rem" }}
          className="d-flex justify-content-center"
        >
          <div
            style={{ height: "5rem", width: "5rem" }}
            className="spinner-border text-custom-color"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        // 검색부분
        <div>
          <Row>
            <Col xs="2">
              <select
                style={{ width: "100%" }}
                value={queryThing}
                onChange={(e) => {
                  // console.log(e.target.value);
                  setQuery(e.target.value);
                }}
              >
                <option value="title">제목</option>
                <option value="content">내용</option>
                <option value="author">작성자</option>
              </select>
            </Col>
            <Col xs="8">
              <input
                type="text"
                style={{ width: "100%" }}
                value={searchString}
                onChange={(e) => {
                  setSearchString(e.target.value);
                }}
              ></input>
            </Col>
            <Col
              className="bg-custom-color cursor-pointer text-white text-center rounded-pill p-1"
              xs="2"
              onClick={() => {
                if (searchString !== "") {
                  // axios({
                  //   method: 'get',
                  //   url: `${root_url}/api/qna?${queryThing}=${searchString}`,
                  //   headers: { 'Content-Type': 'application/json' },
                  // })
                  //   .then((res) => {
                  //     // console.log(res.data.posts);
                  //     setQnaList(res.data.posts);
                  //     setPage({
                  //       pageMaxNo: res.data.pageMaxNo,
                  //       active: 1,
                  //     });
                  //   })
                  //   .catch((e) => {});
                  if (isAdmin) {
                    history.push(`qna?${queryThing}=${searchString}&pageNo=1`);
                  } else {
                    history.push(`qna?${queryThing}=${searchString}&pageNo=1`);
                  }
                }
              }}
            >
              검색하기
            </Col>
          </Row>

          {/* 테이블 부분 */}
          <div style={{ overflowX: "scroll" }}>
            <Table
              size="sm"
              bordered
              hover
              className="mt-3"
              style={{ minWidth: "600px" }}
            >
              {isAdmin ? (
                // admin의 경우 check가 있음
                <thead>
                  <tr className="bg-custom-color text-white">
                    <th style={{ width: "3%" }}>
                      <input type="checkbox" onChange={(e) => onChangeAll(e)} />
                    </th>
                    <th style={{ width: "7%" }}>번호</th>
                    <th>제목</th>
                    <th style={{ width: "10%" }}>작성자</th>
                    <th style={{ width: "15%" }}>날짜</th>
                    <th style={{ width: "7%" }}>조회</th>
                  </tr>
                </thead>
              ) : (
                <thead>
                  <tr className="bg-custom-color text-white">
                    <th style={{ width: "7%" }}>번호</th>
                    <th>제목</th>
                    <th style={{ width: "10%" }}>작성자</th>
                    <th style={{ width: "20%" }}>날짜</th>
                    <th style={{ width: "7%" }}>조회</th>
                  </tr>
                </thead>
              )}

              <tbody>
                {qnaList.length === 0 && (
                  <tr>
                    <td colSpan="5">게시물이 존재하지 않습니다.</td>
                  </tr>
                )}
                {isAdmin //관리자면 체크해서 삭제할 수 있어야함
                  ? qnaList.map((post, index) => {
                      return (
                        <tr key={index} className="cursor-pointer">
                          <td className="smaller-in-md">
                            <input
                              type="checkbox"
                              checked={checkList[post.postNo]}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  // console.log('false -> true');
                                  setCheckList({
                                    ...checkList,
                                    [post.postNo]: true,
                                  });
                                } else {
                                  // console.log('true -> false');
                                  setCheckList({
                                    ...checkList,
                                    [post.postNo]: false,
                                  });
                                }
                              }}
                            />
                          </td>
                          <td
                            className="smaller-in-md"
                            onClick={() => history.push(`qna/${post.postNo}`)}
                          >
                            {post.indent !== 1 ? "↪" : post.articleId}
                          </td>
                          <td
                            onClick={() => history.push(`qna/${post.postNo}`)}
                            className="text-truncate"
                          >
                            {post.passwd ? (
                              <img
                                alt="locked"
                                width="10px"
                                src="https://img.icons8.com/ios/250/000000/lock.png"
                              />
                            ) : (
                              <></>
                            )}
                            {post.title}
                          </td>
                          <td
                            onClick={() => history.push(`qna/${post.postNo}`)}
                            className="text-truncate"
                          >
                            {post.author}
                          </td>
                          <td
                            onClick={() => history.push(`qna/${post.postNo}`)}
                            className="text-truncate"
                          >
                            {dateString(new Date(post.createTime))}
                          </td>
                          <td
                            onClick={() => history.push(`qna/${post.postNo}`)}
                          >
                            {post.viewCount === null ? "0" : post.viewCount}
                          </td>
                        </tr>
                      );
                    })
                  : qnaList.map((post, index) => {
                      return (
                        <tr
                          key={index}
                          className="cursor-pointer"
                          onClick={() => history.push(`qna/${post.postNo}`)}
                        >
                          <td className="smaller-in-md">
                            {post.indent !== 1 ? "↪" : post.articleId}
                          </td>
                          <td className="text-truncate">
                            {post.passwd ? (
                              <img
                                alt="locked"
                                width="10px"
                                src="https://img.icons8.com/ios/250/000000/lock.png"
                              />
                            ) : (
                              <></>
                            )}
                            {post.title}
                          </td>
                          <td className="text-truncate">{post.author}</td>
                          <td className="text-truncate">
                            {dateString(new Date(post.createTime))}
                          </td>
                          <td>
                            {post.viewCount === null ? "0" : post.viewCount}
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </Table>
            {isLoading ? (
              ""
            ) : (
              <PaginationComp
                pageMaxNo={pageInfo.pageMaxNo}
                active={pageInfo.active}
                history={history}
                isAdmin={isAdmin}
                urlBeforePageNo={urlBeforePageNo}
              />
            )}
          </div>
        </div>
      )}
      <Row>
        {isAdmin && (
          <Col
            lg={{ span: 2 }}
            className="bg-secondary cursor-pointer text-white text-center rounded-pill p-1"
            onClick={() => {
              // setWritePost(true);
              const arr = [];
              for (let i in checkList) {
                let accessToken = getBearerString();
                if (checkList[i]) {
                  console.log(i + ")" + checkList[i]);
                  arr.push(parseInt(i));
                  axios({
                    method: "delete",
                    url: `${root_url}/api/admin/notice/${parseInt(i)}`,
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: accessToken,
                    },
                  })
                    .then((res) => {
                      console.log(res);
                      window.location.href = window.location.href; //새로고침해서 새로운 pagination 반영하도록 함
                    })
                    .catch((e) => {
                      if (e?.response?.status === 403) {
                        alert("권한이 존재하지 않습니다.");
                        localStorage.setItem("accessToken", "");
                        window.location.href = "/admin/login";
                      }
                      if (e.response === undefined) {
                        // setRes(false);
                        alert(
                          "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
                        );
                        return;
                      } else {
                        alert(e.response.data.errorMessage);
                      }
                    });
                }
              }
              // console.log(postNoArr);
              setQnaList(
                qnaList.filter((e) => {
                  // console.log(e.articleId);
                  // console.log(arr);
                  return !arr.includes(e.postNo);
                })
              );
            }}
          >
            삭제하기
          </Col>
        )}
        <Col
          lg={{ span: 2, offset: 8 }}
          className="bg-custom-color cursor-pointer text-white text-center rounded-pill p-1"
          onClick={onClickQuestion}
        >
          질문 작성하기
        </Col>
      </Row>
    </Container>
  );
};
export default QNA;
